import { RequestEvent } from 'common/event';
import { NotificationInfo } from 'runtime/data/notificationinfo';

export class NotificationSummaryRequested extends RequestEvent<NotificationSummaryRequested, NotificationInfo[]> {
    constructor(public workItemId: string) {
        super();
    }
}